import React from 'react';
import { footer } from '../data/content';
export function Footer() {
  return <footer className="bg-ink pb-28 pt-10 md:pb-10" data-id="element-79" data-mp="3gezcx2w41p0m">
      <div className="mx-auto flex max-w-page flex-col items-center gap-2 px-5 text-center text-[13px] text-white/70 md:px-8" data-id="element-80" data-mp="3ggtxgg3gzf46">
        <p className="text-white/90" data-id="element-81" data-mp="32m1ch24t96q7">{footer.line}</p>
        <p data-id="element-82" data-mp="36q93j5yqqyrl">
          {footer.supportLabel}{' '}
          <a href={`mailto:${footer.supportEmail}`} className="text-sun underline-offset-4 hover:underline" data-id="element-83" data-mp="3uf0obca04euc">
            {footer.supportEmail}
          </a>
        </p>
        <p data-id="element-84" data-mp="37xyao5wgelp">{footer.copyright}</p>
      </div>
    </footer>;
}